<template>
  <td>
    <v-chip
      class="mr-2"
      v-for="containerSize in slicedContainerSizes"
      :key="containerSize.id"
    >{{containerSize.description}}</v-chip>
    <v-chip v-if="containerSizes.length > displayCount">+ {{containerSizes.length - displayCount}}</v-chip>
  </td>
</template>
<script>
export default {
  props: {
    containerSizes: { required: true },
  },
  computed: {
    slicedContainerSizes() {
      return this.containerSizes.slice(0, this.displayCount);
    },
  },
  data: () => {
    return {
      displayCount: 5,
    };
  },
};
</script>
